module.exports = __webpack_public_path__ + "static/favicon-652ab9201618254e4272facf6bf9bb2d.ico";